import { GuardianPayload } from '_api/types';

import DefaultNewPatient from './newPatient';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { imageUrl, ...GuardianNewPatient } = DefaultNewPatient;

const DefaultNewGuardianWithPatient: GuardianPayload = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  patient: GuardianNewPatient,
  imageUrl: '',
};

export default DefaultNewGuardianWithPatient;
